import { render, staticRenderFns } from "./TitleValueList.vue?vue&type=template&id=1e895a82&scoped=true"
import script from "./TitleValueList.vue?vue&type=script&lang=js"
export * from "./TitleValueList.vue?vue&type=script&lang=js"
import style0 from "./TitleValueList.vue?vue&type=style&index=0&id=1e895a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e895a82",
  null
  
)

export default component.exports